import { useContext } from "react";
import { AuthContext } from "../state/auth";

export function useAuth() {
  return useContext(AuthContext)
}
